<template>
	<AppHeader fixed>
		<SidebarToggler class="d-lg-none" display="md" mobile></SidebarToggler>
		<b-link class="navbar-brand" to="/" style="width: 250px;">
			<img class="navbar-brand-full" src="img/brand/Logo Transparente.png" alt="SPC Telecentinel" style="width: 90%;">
			<img class="navbar-brand-minimized" src="img/brand/Logo Transparente.png" alt="SPC Telecentinel" style="width: 90%;">
			<!--<img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">-->
		</b-link>
		<SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true></SidebarToggler>
		<b-navbar-nav class="d-md-down-none">
		</b-navbar-nav>
		<b-navbar-nav class="ml-auto">
			<b-nav-item class="d-md-down-none">
				Hola, {{user.firstName}} {{user.lastName}}
			</b-nav-item>
			<!--			<b-nav-item class="d-md-down-none">-->
			<!--				<i class="icon-bell"></i>-->
			<!--				<b-badge pill variant="danger">5</b-badge>-->
			<!--			</b-nav-item>-->
			<DefaultHeaderDropdownAccnt/>
			<b-nav-item class="d-md-down-none">
			</b-nav-item>
		</b-navbar-nav>
	</AppHeader>
</template>
<script>
	import {Header as AppHeader, SidebarToggler, AsideToggler} from '@coreui/vue'
	import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

	export default {
		name: 'DefaultHeader',
		components: {
			AsideToggler,
			AppHeader,
			DefaultHeaderDropdownAccnt,
			SidebarToggler
		},
		data: function () {
			return {
				user: JSON.parse(this.$store.state.user)
			}
		}
	}
</script>
